// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import type {VNode} from 'snabbdom';

import {ItemsMenuEl} from 'common/components/items-menu';

import type {TargetProjectSelectorMenu} from './index';

export function template(this: TargetProjectSelectorMenu): VNode {
  const {t} = this.getContext(`i18n`);
  return (
    <div>
      <ItemsMenuEl
        class={{'fill-width': this.params.fillWidth}}
        sel='.target-project-menu'
        attrs={{
          'empty-message': t(`boards.selector.no-projects`),
          ...(this.params.projectSearchFilter && {
            'search-filter': this.params.projectSearchFilter,
            'empty-search-results-message': t(`boards.selector.no-projects-found`),
          }),
        }}
        props={{
          sections: this.helpers.projectListSections(),
        }}
        on={{
          clickItem: this.helpers.fireProjectSelectedEvent,
        }}
      />
    </div>
  );
}
